/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Upload_FileInputs */

const en_dialog_upload_file = /** @type {(inputs: Dialog_Upload_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload a file`)
};

const es_dialog_upload_file = /** @type {(inputs: Dialog_Upload_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir un archivo`)
};

/**
* | output |
* | --- |
* | "Upload a file" |
*
* @param {Dialog_Upload_FileInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_upload_file = /** @type {((inputs?: Dialog_Upload_FileInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Upload_FileInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_upload_file(inputs)
	return en_dialog_upload_file(inputs)
});